export default {
  name: 'NotWorking',
  methods: {
    goBack() {
      window.history.go(-1);
    },
  },
  mounted() {
    if (window.performance?.navigation.type === 1) {
      this.goBack();
    }
  },
};
